module.exports = __webpack_public_path__ + "img/users-cog.f896a5da.svg";